export default "__VITE_ASSET__2ozTXELs__"